<template>

	<a-card :bordered="false" class="widget-1">
		<a-statistic
			:title="title"
			:value="value"
			:prefix="prefix"
			:suffix="suffix"
			:precision="0"
			class="text-success"
			:class="'text-' + status"
		>
		</a-statistic>
		<div class="icon"><Icon :icon="icon" class="icon-inner" /></div>
	</a-card>

</template>

<script>
import { Icon } from '@iconify/vue2';
	export default ({
		props: {
			title: {
				type: String,
				default: "",
			},
			value: {
				type: Number,
				default: 0,
			},
			prefix: {
				type: String,
				default: "",
			},
			suffix: {
				type: String,
				default: "",
			},
			icon: {
				type: String,
				default: "",
			},
			status: {
				type: String,
				default: "success",
			},
		},
    components: {
      Icon
    },
		data() {
			return {
			}
		},
	})

</script>

<style lang="scss" scoped>
.icon-inner {
  font-size: 36px;
  color: white;
}
</style>